import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Label,
} from "reactstrap";
import Select from "react-select";
import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

//se crea el componente de CrearUsuario.
const CrearUsuario = () => {
  const [postNombre, setPostNombre] = useState([]);
  const [postCorreo, setPostCorreo] = useState([]);
  const [postContraseña, setPostContraseña] = useState([]);
  const [postArea, setPostArea] = useState([]);
  const [postTipoUsuario, setPostTipoUsuario] = useState([]);
  const [postAprobador, setPostAprobador] = useState([]);
  const [options, setOptions] = useState([]);
  const [area, setArea] = useState([]);
  const [usuario, setUsuario] = useState([]);

  //se usa metodo GET para recibir la informacion de la API que necesitemos.

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback.azurewebsites.net/api/v1/ObtenerUsuarios",
    })
      .then((Response) => {
        setOptions(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback.azurewebsites.net/api/v1/ObtenerAreas",
    })
      .then((Response) => {
        setArea(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback.azurewebsites.net/api/v1/ObtenerTipoUsuario",
    })
      .then((Response) => {
        setUsuario(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  //se crea un metodo post para enviar informacion que recibamos de los usuarios
  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback.azurewebsites.net/api/v1/CrearUsuario",
      data: {
        nombre: postNombre,
        correo: postCorreo,
        contrasena: postContraseña,
        area: postArea,
        tipoUsuarioId: postTipoUsuario,
        aprobadorId: postAprobador,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert(" creada con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };
  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };
  const [selectedOption1, setSelectedOption1] = useState(null);

  return (
    <>
      {/* Page content */}
      <button
        variant="contained"
        className="btn btn-primary btn-lg"
        color="primary"
        onClick={handleOpenModalTest}
      >
        Nuevo
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">USUARIO</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <br></br> <br></br>
                  <Form>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Nombre
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-username"
                              placeholder=""
                              type="text"
                              onChange={(e) => setPostNombre(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              Correo
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-last-name"
                              placeholder=""
                              type="text"
                              onChange={(e) => setPostCorreo(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-password"
                            >
                              Contraseña
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-password"
                              type="password"
                              onChange={(e) =>
                                setPostContraseña(e.target.value)
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <Label for="liderSelect">
                              Seleccione el Tipo de Usuario
                            </Label>
                            <Input
                              type="select"
                              id="liderSelect"
                              name="liderSelect"
                              onChange={(e) =>
                                setPostTipoUsuario(e.target.value)
                              }
                            >
                              <option value="">
                                Seleccione el tipo de usuario
                              </option>
                              <option value="1">Administrador</option>
                              <option value="2">Aprobador</option>
                              <option value="3">Proveedor</option>
                              <option value="4">Comprador</option>
                              <option value="5">Representante legal</option>
                              <option value="6">Solicitante</option>
                              {usuario.map((item) => (
                                <option value={item.id}>
                                  {item.tipoUsuario}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <Label for="liderSelect">Seleccione el Area</Label>
                            <Input
                              type="select"
                              id="liderSelect"
                              name="liderSelect"
                              onChange={(e) => setPostArea(e.target.value)}
                            >
                              <option value="">Seleccione el Area</option>
                              {area.map((item) => (
                                <option value={item.nombreArea}>
                                  {item.nombreArea}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <div className="pl-lg-4">
                      <Row></Row>
                    </div>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <Label for="liderSelect">Seleccione el Líder</Label>
                            <Input
                              type="select"
                              id="liderSelect"
                              name="liderSelect"
                              onChange={(e) => setPostAprobador(e.target.value)}
                            >
                              <option value="">Seleccione el Líder</option>
                              {options.map((item) => (
                                <option value={item.id}>{item.nombre}</option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label for="tipoUsuarioID">Tipo de Aprobador</label>
                            <select
                              id="tipoUsuarioID"
                              className="form-control"
                              value={selectedOption1}
                              onChange={handleChange}
                            >
                              <option value="">Seleccionar...</option>
                              <option value="1">Abastecimeinto</option>
                              <option value="2">Directo</option>
                              <option value="3">Juridico</option>
                              <option value="4">Tecnico</option>
                              <option value="5">Representante Legal</option>
                              <option value="0">N/A</option>
                            </select>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <button
                          className="btn btn-primary btn-lg"
                          color="primary"
                          onClick={postData}
                        >
                          ENVIAR
                        </button>
                      </Row>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default CrearUsuario;

/* <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-username"
                              >
                                Area de trabajo
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-username"
                                placeholder=""
                                type="text"
                                onChange={(e) => setPostArea(e.target.value)}
                              />
                            </FormGroup>
                          </Col> */
